import React, { useEffect, useState } from "react";
import styles from "./Hero.module.scss";
import homeStyles from "../../../styles/Home.module.scss"
import Image from "next/image";
function Hero() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className={styles.heroSection}>
      <div className={styles.backgroundOverlay} />
      <div className={styles.container}>
        <div className={styles.grid}>
          <div
            className={`${styles.leftColumn} ${
              isVisible ? styles.animateLeft : styles.hidden
            }`}
          >
            <div className={styles.content}>
              <div className={"tag"}>
                <span> Next-Generation Commerce</span>
              </div>

              <h1 className="heading" style={{marginBottom:0}}>
                The Future of
                <br />
                <span className={homeStyles["span-gradient"]}> Agentic Commerce</span>
              </h1>
              <p className="subHeading">
                Revolutionize your e-commerce with AI-powered shopping
                assistants that understand, learn, and act autonomously to
                deliver personalized experiences at scale.
              </p>

              <div className={styles.features}>
                <div className={styles.row}>
                  <Image
                    src="/features-icon2.webp"
                    alt="icon1"
                    width={23.33}
                    height={23.33}
                  />
                  <div> AI Shopping Assistant</div>
                </div>
                <div className={styles.row}>
                  <Image
                    src="/features-icon2.webp"
                    alt="icon1"
                    width={23.33}
                    height={23.33}
                  />
                  <div>Consumer Order History Analyzer</div>
                </div>
                <div className={styles.row}>
                  <Image
                    src="/features-icon2.webp"
                    alt="icon1"
                    width={23.33}
                    height={23.33}
                  />
                  <div> Complaint Management</div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`${styles.rightColumn} ${
              isVisible ? styles.animateRight : styles.hidden
            }`}
          >
            <div className={styles.imageWrapper}>
              <img
                src="https://images.pexels.com/photos/5632402/pexels-photo-5632402.jpeg?auto=compress&cs=tinysrgb&w=800"
                alt="AI Shopping Assistant Interface"
                className={styles.image}
              />
              <div className={styles.imageOverlay} />
              <div className={styles.assistantBox}>
                <div className={styles.assistantContent}>
                  <div className={styles.botIcon}>
                    {/* <Bot className={styles.botSvg} /> */}
                    <Image
                      src="/agent-icons/ai.svg"
                      alt="icon1"
                      width={20}
                      height={20}
                    />
                  </div>
                  <div>
                    <p className={styles.assistantTitle}>AI Assistant Active</p>
                    <p className={styles.assistantSubtitle}>
                      Analyzing customer preferences...
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
